import { render, staticRenderFns } from "./QuotationDocument.vue?vue&type=template&id=72493989"
import script from "./QuotationDocument.vue?vue&type=script&lang=ts"
export * from "./QuotationDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports